"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSize = exports.ButtonTypes = exports.Button = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const rc_motion_1 = __importDefault(require("rc-motion"));
const Loading_1 = require("../Icons/Loading");
const utils_1 = require("../utils");
const HiddenText_1 = __importDefault(require("../HiddenText"));
const Icons_1 = require("../Icons");
const types_1 = require("./types");
Object.defineProperty(exports, "ButtonTypes", { enumerable: true, get: function () { return types_1.ButtonTypes; } });
Object.defineProperty(exports, "ButtonSize", { enumerable: true, get: function () { return types_1.ButtonSize; } });
const Button = (_a) => {
    var { children, className, disabled, icon, loading, noHover, noPadding, onClick, onDisabledClick, position = "left", size = types_1.ButtonSize.Small, type = types_1.ButtonTypes.Default, expandable, defaultExpanded = false, expanded, floating, fullWidth } = _a, props = __rest(_a, ["children", "className", "disabled", "icon", "loading", "noHover", "noPadding", "onClick", "onDisabledClick", "position", "size", "type", "expandable", "defaultExpanded", "expanded", "floating", "fullWidth"]);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(expanded ? expanded && expandable : defaultExpanded && expandable);
    const classes = (0, classnames_1.default)("gerudo-btn", type, className, size, `fit-to-${position}`, {
        loading,
        disabled,
        "no-padding": noPadding,
        "no-hover": noHover,
        "full-width": fullWidth,
        expandable,
        expanded: isExpanded && expandable,
        floating,
    });
    (0, react_1.useEffect)(() => {
        if (typeof expanded !== "undefined") {
            setIsExpanded(expanded || false);
        }
    }, [expanded]);
    const handleClick = (e) => {
        if (loading || disabled) {
            e.preventDefault();
            onDisabledClick && onDisabledClick(e);
            return false;
        }
        if (onClick) {
            onClick(e);
        }
    };
    const handleExpandToggle = expandable
        ? (e) => {
            e.preventDefault();
            e.stopPropagation();
            const expandedStateControlled = expanded ? expanded : !isExpanded;
            setIsExpanded(e.type === "mouseenter" && defaultExpanded ? true : expandedStateControlled);
        }
        : () => null;
    const shouldShowLoadingIcon = Boolean(loading && !disabled);
    let buttonIcon = icon;
    if (shouldShowLoadingIcon) {
        buttonIcon = react_1.default.createElement(Loading_1.LoadingIcon, { className: "gerudo-icon-loading" });
    }
    // If the button has content other than the icon, the icon should be hidden from screen readers
    if (buttonIcon && children) {
        buttonIcon = react_1.default.cloneElement(buttonIcon, { "aria-hidden": true });
    }
    if (buttonIcon && buttonIcon.props.size === undefined) {
        buttonIcon = react_1.default.cloneElement(buttonIcon, { style: { fontSize: "var(--button-icon-default-size)" } });
    }
    const content = (react_1.default.createElement("span", { className: (0, classnames_1.default)("wrap", { isExpanded }) },
        buttonIcon,
        expandable ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(rc_motion_1.default, Object.assign({ removeOnLeave: true, visible: isExpanded }, utils_1.horizontalCollapseMotion), ({ className, style }) => {
                return (react_1.default.createElement("div", { className: className, style: style }, children && react_1.default.createElement("span", { className: "button-content" }, children)));
            }),
            !isExpanded && react_1.default.createElement(HiddenText_1.default, null, children))) : (children && (react_1.default.createElement("span", { className: "button-content" },
            children,
            "href" in props && props.target === "_blank" && react_1.default.createElement(Icons_1.ExternalLinkIcon, null))))));
    if ("href" in props) {
        const { href, target } = props, leftProps = __rest(props, ["href", "target"]);
        // Can't figure out how to make it a compile error to have htmlType when href is present, even with Union types...
        delete leftProps.htmlType; // eslint-disable-line @typescript-eslint/no-explicit-any
        return (react_1.default.createElement("a", Object.assign({ href: href, target: target, className: classes, onClick: handleClick, onMouseEnter: handleExpandToggle, onMouseLeave: handleExpandToggle }, leftProps), content));
    }
    else {
        let leftProps = props;
        let buttonType = "button";
        if ("htmlType" in props) {
            const { htmlType = "button" } = props, leftButtonProps = __rest(props, ["htmlType"]);
            delete leftButtonProps.target; // eslint-disable-line @typescript-eslint/no-explicit-any
            leftProps = Object.assign({}, leftButtonProps);
            buttonType = htmlType;
        }
        return (react_1.default.createElement("button", Object.assign({ className: classes, onClick: handleClick, disabled: disabled || loading, onMouseEnter: handleExpandToggle, onMouseLeave: handleExpandToggle, type: buttonType }, leftProps), content));
    }
};
exports.Button = Button;
exports.default = Button;
//# sourceMappingURL=Button.js.map